let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cbUc0")).then(() => parcelRequire('3AFrq'));